function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bx-world",
  d: "M34.4,3A31.4,31.4,0,1,0,65.8,34.4,31.435,31.435,0,0,0,34.4,3ZM9.28,34.4a24.971,24.971,0,0,1,1.352-8.065l4.928,4.926,6.28,6.28v6.28l6.28,6.28,3.14,3.14V59.3A25.147,25.147,0,0,1,9.28,34.4Zm45,15.3a13.129,13.129,0,0,0-7.316-2.74v-3.14a6.28,6.28,0,0,0-6.28-6.28H28.12V28.12a6.28,6.28,0,0,0,6.28-6.28V18.7h3.14a6.28,6.28,0,0,0,6.28-6.28V11.13A25.043,25.043,0,0,1,54.278,49.7Z",
  transform: "translate(-3 -3)",
  fill: "#ac1ede"
});

var SvgBxWorld = function SvgBxWorld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.799,
    height: 62.799,
    viewBox: "0 0 62.799 62.799",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxWorld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx-world.ed08b578.svg";
export { ForwardRef as ReactComponent };